<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
          {
        "num_cand": "U2FsdGVkX1/7zYU/nn10aS2c+kHPOnqpx88erj2OHQY=",
        "cpf": "U2FsdGVkX19R7PrHe6gtOZJCv6zVbm8kJqRmWmEiOVU="
      }, {
        "num_cand": "U2FsdGVkX19byL+ENRCio//Ss4isOIg8CnzbBm+bur8=",
        "cpf": "U2FsdGVkX188fAKKQT2X3Zf0mSEF1RO5WhrX9X7BNXo="
      }, {
        "num_cand": "U2FsdGVkX1+6/axxBBSwpnkDZzzk01pCa8/PjKgTxQ0=",
        "cpf": "U2FsdGVkX1/PrVXneIvWuDTcZoPDQGr4Jk3tMfEw/ao="
      }, {
        "num_cand": "U2FsdGVkX19QuC8cJcg1FTNt6Ea53U45xH9/8jBMU6I=",
        "cpf": "U2FsdGVkX1/Q2kV0fpAhU6eAdQqQs/T1eKjBwx5jbmI="
      }, {
        "num_cand": "U2FsdGVkX19AYYFZQg6c+Gl0JcQa0TZRl4T+9z2hneM=",
        "cpf": "U2FsdGVkX1/Fx02O7TShISKA0D9PsW5MAWzRja1MH6M="
      }, {
        "num_cand": "U2FsdGVkX1+N79nH5bmcUghGoyY+LBAxD1Hslerxfko=",
        "cpf": "U2FsdGVkX18AdCMwI2q5AVkc18bKqR+xOPtuAfG84/M="
      }, {
        "num_cand": "U2FsdGVkX19mfbCx+RkmzrY1FBgMJCh8b0QYfB8w/SY=",
        "cpf": "U2FsdGVkX1/4ANIvvgPEGwbvvqXv/SvLT+Js8vLUsy0="
      }, {
        "num_cand": "U2FsdGVkX19cUhwsqQNTZXjoBhVNXiz8OCvUwX5Odog=",
        "cpf": "U2FsdGVkX1+LBGTGyC1qMU3OcJnRERWOzK+sCajdTdM="
      }, {
        "num_cand": "U2FsdGVkX18AaeVkUSeczq+FJdTU5jVnqohWvwq2NcA=",
        "cpf": "U2FsdGVkX1/MXaHA3Bf+ezX5NDfPWftLVfYWyAeAP5Q="
      }, {
        "num_cand": "U2FsdGVkX18SZCXBHSQcNHdsPFXF893Kp8MAmhUQeSA=",
        "cpf": "U2FsdGVkX183XZU5Pf3PQY+nPEAEUNypc/Nw6fOG9Qc="
      }, {
        "num_cand": "U2FsdGVkX18nzv1yiRphTXuqQvWuCx0eveMg0Ky/6EI=",
        "cpf": "U2FsdGVkX19ftdPSTKGbkRfVVTYEvm1gKdOLVyHCmRk="
      }, {
        "num_cand": "U2FsdGVkX1/0/S5szSKHC81Xwp/3HN7m6X/03QVNfC8=",
        "cpf": "U2FsdGVkX1+ZfILAcBm1ZrQmga8m1hMdAaZjgHTFjw0="
      }, {
        "num_cand": "U2FsdGVkX18yXvSjH2OX0ViUmlQgRcffJ2CXGsIL62w=",
        "cpf": "U2FsdGVkX1/Pp2msGW6RRTobHaOFvcMp1l4mEV5qgXw="
      }, {
        "num_cand": "U2FsdGVkX19jhd9kjoDzBQsEdsY8YKoXmBBsDHiP3SM=",
        "cpf": "U2FsdGVkX1/MWSwhuRabr/kuMH8wnaVGCLOZufZz2SY="
      }, {
        "num_cand": "U2FsdGVkX197ckNP8a6Imi8IvuA8fXUlk/swuBEbMdY=",
        "cpf": "U2FsdGVkX1/aPN3nU1Er1qhih4XTPnKh1N6Puv/rdUA="
      }, {
        "num_cand": "U2FsdGVkX18SABUmqCAKCwnqE6Jh3BUL08XlqDQOnHM=",
        "cpf": "U2FsdGVkX1+vQyAtqmz0tq7d+n0wUiH5OtIddzsdpdM="
      }, {
        "num_cand": "U2FsdGVkX1/XAS8NvrBaQcZyQYh2nNyHRRgvcXEEmlc=",
        "cpf": "U2FsdGVkX18Nuczsp0X33z5d4raJgxEdg4bJknaBkNI="
      }, {
        "num_cand": "U2FsdGVkX1/N26ozbV2RzfZP48iHperBmBPG5R6b2iM=",
        "cpf": "U2FsdGVkX19JrKnmEQL9DeF8VhgldGq+XexKCQowe0Y="
      }, {
        "num_cand": "U2FsdGVkX1/We3MnHQs99M+KyeREecHR2nuSS2TL+8w=",
        "cpf": "U2FsdGVkX18YKFZT2oXDzHXhvGR+xioSpl5Xm/49CyA="
      }, {
        "num_cand": "U2FsdGVkX1+CQmXdZEeC3cZsTYIseFkz6HC7sg5hY8c=",
        "cpf": "U2FsdGVkX18B/GmDgnyCqgyOfgzyrd2KY+hZnj9E5P4="
      }, {
        "num_cand": "U2FsdGVkX18rK+Z3kJiUrtEmlQcLYO6Yp2gsYTkdUNw=",
        "cpf": "U2FsdGVkX18MsMZMKQrRra1Pr8xfNYQ14dh8jMv0vX4="
      }, {
        "num_cand": "U2FsdGVkX19T4OTtgJnzzSww60o2INHlK46/z7W8Nk0=",
        "cpf": "U2FsdGVkX19BaBykcDMWwDnX4IuMOJ8GnZm81KHF+Ss="
      }, {
        "num_cand": "U2FsdGVkX1+dnqL7cLbDZEreGp1BYCgpr5/xGWs2UEU=",
        "cpf": "U2FsdGVkX19QNd7FPbNTJMwB2NqH5xmpwWe2RCfQdmk="
      }, {
        "num_cand": "U2FsdGVkX19nWtlEJB1ARAiHLnoL6UTD7r1EqIgiB2Y=",
        "cpf": "U2FsdGVkX18wGPbeoRzazGO2KOJFBXqITVtdBbpZz1Q="
      }, {
        "num_cand": "U2FsdGVkX19GEJGIZTgxNNTboEBIrdDWo0YS8YmTf+M=",
        "cpf": "U2FsdGVkX1+sLRYScrr5eP43fcUO8zKKxf4aPHjpk74="
      }, {
        "num_cand": "U2FsdGVkX19cvqsqgsl4zuGh+FPP7+eC4uEDP4jM6y4=",
        "cpf": "U2FsdGVkX1+Ea9npNN2XJ2BvuGILhqIUMPcvKdQmDk0="
      }, {
        "num_cand": "U2FsdGVkX1/d4G0oZj2BKOo2NV73kzK2JIkw3p0V8Ok=",
        "cpf": "U2FsdGVkX191i0/XCwRUY7/QxF2xkyyEG2oo/H1quno="
      }, {
        "num_cand": "U2FsdGVkX19HIcgS72kZInI5MUhy24z9PQwlSdBT5Rk=",
        "cpf": "U2FsdGVkX19rjvQzI972bO2odMY7mX9Uzhl9EHPl2cE="
      }, {
        "num_cand": "U2FsdGVkX19m41JZ1nlVy20pDJ6COcA4oEHn+HZ9VhE=",
        "cpf": "U2FsdGVkX1+ZL3QEArtHkWZBDRpJ//Hp+5SDY+CUdhU="
      }, {
        "num_cand": "U2FsdGVkX1/iTzxU2y9IasMsW8DVBu2X23VBsIyL+Z8=",
        "cpf": "U2FsdGVkX18t9DWTXi6Km9+DDEw5FxoYUy7efogfMok="
      }, {
        "num_cand": "U2FsdGVkX183lHW8EAkm/kPnvFZxx7jiJPu3RCmsqDQ=",
        "cpf": "U2FsdGVkX1+1ItursZR9U6vcxSaCqbxxsnBzlLrPyOc="
      }, {
        "num_cand": "U2FsdGVkX18yc5hcInn2MVzIqcWRhZxGRQg4ZT9WiBQ=",
        "cpf": "U2FsdGVkX19C3Dock75N+txzoScYQodvqEYwwlqe6BA="
      }, {
        "num_cand": "U2FsdGVkX1/LOTpdD0ztVGUkzyedje1Iq3YWNYyys/M=",
        "cpf": "U2FsdGVkX18IzYWORSy4qXIu2kBK0fDXQ2KKc4uZ3nQ="
      }, {
        "num_cand": "U2FsdGVkX188L2zkKqFcyjuh4HrEHFKnCsvlxLVDIXE=",
        "cpf": "U2FsdGVkX1/uwq/4uVZdro1upc8AfK7ZyeS/0SBJdmo="
      }, {
        "num_cand": "U2FsdGVkX1+9RmpE53bt+bDmVgx+hmmYbWNh+0BIWMc=",
        "cpf": "U2FsdGVkX1+qFqJFJUn5iOpagWfTLwkj1EEUhAKRhUc="
      }, {
        "num_cand": "U2FsdGVkX1/sNMnuoi0NHhmpm16aTRR1OtsMmIXFkIg=",
        "cpf": "U2FsdGVkX188wF8AyNsfbdpUfpEjS6lVq8XqVbBGtgU="
      }, {
        "num_cand": "U2FsdGVkX1+2Pi5jMfLT7tq67VSoKARnIe4vHyu1SU8=",
        "cpf": "U2FsdGVkX1/MRi3cBCyM2iwAoLgpMXtyoKeJZuBwgMI="
      }, {
        "num_cand": "U2FsdGVkX1+bIznbyLLh62jzwPMAbn675VSn6L4CyTw=",
        "cpf": "U2FsdGVkX1/+Ss48ivWb12xyvvhTiyb5KbCkeoPuuvk="
      }, {
        "num_cand": "U2FsdGVkX1/9DjTEHtExH+doBw7chms4fvDdxJIlUuw=",
        "cpf": "U2FsdGVkX1+fxGVL0uRLfEV3GoEPFMYwMJQgyEqHbUQ="
      }, {
        "num_cand": "U2FsdGVkX19oehDq+N1+HTz8rpSq9OCEf6zD9wN0SRE=",
        "cpf": "U2FsdGVkX1/+K/aamAQZh8kpuOzuX1H4qJPjVO2o8nw="
      }, {
        "num_cand": "U2FsdGVkX18cVmzsAFpeenRiPG6Ekh8MLOnmgVuJssc=",
        "cpf": "U2FsdGVkX1+zvlDbsQMhJnl3POIV32xDLA4S5oAGVdI="
      }, {
        "num_cand": "U2FsdGVkX18bXdgDNf8Z0AKU0k0vBJsdRAcURMr2/Xg=",
        "cpf": "U2FsdGVkX19X6EH5hMNfRXQ5xFy0FvfuA67QQ3fJ5ws="
      }, {
        "num_cand": "U2FsdGVkX19oFj6Kvr46+24RADQOsESUeQAD/Jz3U4M=",
        "cpf": "U2FsdGVkX1+H8gNWHeLlCos1rmg4OyWup5BUs3FUcr0="
      }, {
        "num_cand": "U2FsdGVkX1+ezgb4Xe3N4AT7ZQojT1zNRtND7xT6syM=",
        "cpf": "U2FsdGVkX190wc2BVn3Z9/zXtZJpogFAVFFQnHthAxY="
      }, {
        "num_cand": "U2FsdGVkX1+bBemNh7AYdGrcLcXPp+ZVaK7f6RfoFDA=",
        "cpf": "U2FsdGVkX1+fNEi02DwiTYeU1TRM9k27JZRtVFdgj6k="
      }, {
        "num_cand": "U2FsdGVkX1/HWhdpT1AtQoY4oYNzgpJqmWKPYZ/BuCA=",
        "cpf": "U2FsdGVkX18tOa6aWzL7c4P+oykH7W8mK0lPwBE+uxM="
      }, {
        "num_cand": "U2FsdGVkX1/9r4GTKWtaBjIeETgR+lfLdCYjPR1OYsA=",
        "cpf": "U2FsdGVkX18k9JqPs6JV3/0Rwyb28HmMArG/uWPe2rE="
      }, {
        "num_cand": "U2FsdGVkX18juksoWaRHWGq6FqZpyOK7Ky1vI4WPxe0=",
        "cpf": "U2FsdGVkX1+u5zCODpclCV7TxBfeKKwfRUEivl6SKaA="
      }, {
        "num_cand": "U2FsdGVkX194gvPxc/RmTcFd2deb0j2oYJFVQgvPSsU=",
        "cpf": "U2FsdGVkX187XB60EtkmpNd2RaX5UtVo14xoFSS4Wpc="
      }, {
        "num_cand": "U2FsdGVkX19M47sHiqmjiwMfqIMdJU1ITFQxX5S+O4Q=",
        "cpf": "U2FsdGVkX18QufDuU8d+Fr3FfqXs22MAiY+AFm/wbVQ="
      }, {
        "num_cand": "U2FsdGVkX1/A8qKMuj8UyTi/zliK0jXam8nsJyWSVPE=",
        "cpf": "U2FsdGVkX1+eZEsi3R8hOEqTk4m37tS6r5XqO7hfCCo="
      }, {
        "num_cand": "U2FsdGVkX1/llM8bw6yU6zBEuJvYBnlgToW3O4oRrJ4=",
        "cpf": "U2FsdGVkX1/6NLVz2lmcvIVsTjCA6e9cVSuTOlRZHCg="
      }, {
        "num_cand": "U2FsdGVkX1+UmxLgL4Z4yfxd/JeWdyptkwEq77lYX1M=",
        "cpf": "U2FsdGVkX18qCbp/9o1T9tFnJv93G0OQv6oSdUTG+F4="
      }, {
        "num_cand": "U2FsdGVkX1/hV+CU2mH8lmLk5mEd4UCEZVLaQEbvq+I=",
        "cpf": "U2FsdGVkX18+IXtKqme37tMfULwnpC3C6+gKv72vVVc="
      }, {
        "num_cand": "U2FsdGVkX18mQ6qvrjUlHXjEndm2o1YarnEKmFnfo4w=",
        "cpf": "U2FsdGVkX194SuMvTN5yfxugpyq/MH2n1HPncgMnXaA="
      }, {
        "num_cand": "U2FsdGVkX19YQaPCjsZ+1bLyRo8Bdf/QFhA/QSxrTYg=",
        "cpf": "U2FsdGVkX184l8MZ5i9T4NJK6Ld57BikZaUgxBjVofQ="
      }, {
        "num_cand": "U2FsdGVkX1/IvpVg+bTVGeg3qp7FUnE+UGOq2ELcbRQ=",
        "cpf": "U2FsdGVkX1/wkK/UYfjEjgFsvEVwlO6C3pmqFCsWwuo="
      }, {
        "num_cand": "U2FsdGVkX19htCB7prLzK5BgrA3/lCaEAUNcY+R6JNQ=",
        "cpf": "U2FsdGVkX19KUSdurRYNPIjKQzzG6lsEmCB6T7PDq9c="
      }, {
        "num_cand": "U2FsdGVkX1+iDZQPmczMk5HIat3AanFyqtwqD9mXMNM=",
        "cpf": "U2FsdGVkX1+iqiWptTaSjYC4GKa+6Ci27JgOwn0O89A="
      }, {
        "num_cand": "U2FsdGVkX18aUg/HxEaKxkWdqEcdVl9DYN8iJm/EzJM=",
        "cpf": "U2FsdGVkX18DysQ3c7/qtNYpbU0YND3ssB9vvIMNMLY="
      }, {
        "num_cand": "U2FsdGVkX18U/nMReuuRnM5srZwTcUDfYcM+uwovBSw=",
        "cpf": "U2FsdGVkX18sytiz3u5TsJQ55371SLs2b7PqdCqt2s4="
      }, {
        "num_cand": "U2FsdGVkX182MeUr0e+4fR8Fwy8iDAzz9m7KI4qXQA8=",
        "cpf": "U2FsdGVkX19+DpFTcvyJpVZB/XHBMwkfTpQT2+0C8no="
      }, {
        "num_cand": "U2FsdGVkX1943apHKNQgGUWfZ+cHxTY8xqbu5w1OY9U=",
        "cpf": "U2FsdGVkX19UIlRYnNxiFoJN5T2Znjy6+eBLh19mt+4="
      }, {
        "num_cand": "U2FsdGVkX19eTosjfXIL1tPgVcOW3hnCQzxHgwBtlaY=",
        "cpf": "U2FsdGVkX19wAGhn1EO0JKmjyyJfOeEXXIynkhyZaz0="
      }, {
        "num_cand": "U2FsdGVkX1+pBw09XaVmvSPdaj1ddUF8tcz4xrM0usw=",
        "cpf": "U2FsdGVkX18gHIKIKNACug1YLtFtLu+wESkPapqM3qs="
      }, {
        "num_cand": "U2FsdGVkX197BER1kQdPmIxSPIGQxGlb+m9Cui5VGoc=",
        "cpf": "U2FsdGVkX1/xKjA2fJ3cI1VYAbPSzqMDdQda19C43jw="
      }, {
        "num_cand": "U2FsdGVkX18XKSOxWfhyglHIBA/rFdORv9vJqOb3CN8=",
        "cpf": "U2FsdGVkX18wCg/ilfF82EvSUp+mkuYyPsvPao35k6U="
      }, {
        "num_cand": "U2FsdGVkX1+X2R2tTWVrgCLEvWqLLwzFT4buhsaNh58=",
        "cpf": "U2FsdGVkX18EMLhARvmw7zKBpMDcmV0MqBfpy1yiB5U="
      }, {
        "num_cand": "U2FsdGVkX1+Q4HPN36pG6Jvh8ZdqHm8QMyPB536oAZc=",
        "cpf": "U2FsdGVkX19c4tC9uz+/XgHVULPPSQKOCq5R97s6WKk="
      }, {
        "num_cand": "U2FsdGVkX18XFBvvuf7cRSSB4G2jHYWyapKJoc/OFhY=",
        "cpf": "U2FsdGVkX1/ZWG6tRdGHnWr+DxBzrI0fH4LRFxj0Hg0="
      }, {
        "num_cand": "U2FsdGVkX193iL5HrVYr+DncbStd/+044kYMpiG2UHA=",
        "cpf": "U2FsdGVkX1/gWkt1ZR5wUGpS/MR+4suOBmIZgGLjSWY="
      }, {
        "num_cand": "U2FsdGVkX18yWafhTq4ShqMuOa3rPHR1LQegxHqMmg4=",
        "cpf": "U2FsdGVkX1/4p8YV0UG+5BZWGMm9RCK2CZMkB4vQHDw="
      }, {
        "num_cand": "U2FsdGVkX19Z2QBT0lv1gGsn66lUvXZnmuuOZ+s8sFw=",
        "cpf": "U2FsdGVkX18IT3jRr5DNCT9+CToionPJhESo4hJYeew="
      }, {
        "num_cand": "U2FsdGVkX1/POdGof5tVWJhw0HYsNZfqbhCzz83jfVo=",
        "cpf": "U2FsdGVkX1+lkSwNE0jIYwipTTSYWTws9Gj76W9dtCQ="
      }, {
        "num_cand": "U2FsdGVkX19lxp+g6JKKbgwHhpdC7sdTyGyH7yP8e/Q=",
        "cpf": "U2FsdGVkX19TqYzbgzMtX0i0YPhLwZ1lKBqrTvJ7DDk="
      }, {
        "num_cand": "U2FsdGVkX180b4biK75FBiv7mzUtLGpuRAY30kD31I8=",
        "cpf": "U2FsdGVkX18mCmawt6hSK29PbkIR/lVlwTYHrAnRj/s="
      }, {
        "num_cand": "U2FsdGVkX192p+nR3k+0w3OIXoFnYjpEfWrgeMqR8jE=",
        "cpf": "U2FsdGVkX197pKYouJxALtm6hEhA8KH2hWy7v8ESlo8="
      }, {
        "num_cand": "U2FsdGVkX18AIvMT9g2SIo8XWVgcSRduKsP0jLKUf40=",
        "cpf": "U2FsdGVkX183AYgdLz7QdS5U7BMQfixoHJM1qGhRu84="
      }, {
        "num_cand": "U2FsdGVkX19hlBtc1jMGupsMb7qPxl/Y70VNuG7MFb8=",
        "cpf": "U2FsdGVkX1+xmXVQ5i+gph4Jv4TePtXnICWut3cBRes="
      }, {
        "num_cand": "U2FsdGVkX18t2OQx6iDJUF6VUTr/Z12PmgRkcIhgupI=",
        "cpf": "U2FsdGVkX19bKDz99Z62gRJiAQANtAWqzOvA90y5waA="
      }, {
        "num_cand": "U2FsdGVkX19el4TBCU88f788R5Nd2CctwUeATOwZ62g=",
        "cpf": "U2FsdGVkX18cF4ne5BLUrGVoXh+DZArqgu9X5S/K0lc="
      }, {
        "num_cand": "U2FsdGVkX1+/NOIgR4SXUfKPTiJyxYy5EiUSHcJeOdc=",
        "cpf": "U2FsdGVkX1+UNj3fjIj+dxK2CtIe/7E89PZwtrJOJcA="
      }, {
        "num_cand": "U2FsdGVkX18Crl0PMWO3PExgJ12pKas6yn0eQ3ZxYIw=",
        "cpf": "U2FsdGVkX1+H5LZtPRxVUn7UVOTj4Yd4ZMEcc0b1OgM="
      }, {
        "num_cand": "U2FsdGVkX1/ZPmceDPgI65sAxBXEl/3Z8ARqno6ZdME=",
        "cpf": "U2FsdGVkX18fmwG9xSdTUfpok80c/ESo4Hq+9BuXhQg="
      }, {
        "num_cand": "U2FsdGVkX19Bz+Zdq0/s915Kv/U3hQgLj4X9Xy141s8=",
        "cpf": "U2FsdGVkX181zPxZ2Rv/f5/nLJcMK6FFKIhP6WYgGQk="
      }, {
        "num_cand": "U2FsdGVkX19saXhuix3tn2+If9c2FQktu+q4juCH7No=",
        "cpf": "U2FsdGVkX18i4bswz9Sa7gLsebiXL1sXTo+D+mWzHTY="
      }, {
        "num_cand": "U2FsdGVkX19PJl+BIy4HKtrnF99pk7g2PUZIxfrYWzI=",
        "cpf": "U2FsdGVkX1/7fMxqIjGnc87KV1xhCRsNGqs3JgKDbbA="
      }, {
        "num_cand": "U2FsdGVkX1/+BGzE+1W7a0nl5FW2/kFcYiFWnpQnMM0=",
        "cpf": "U2FsdGVkX18ofrkGDVqhplCXtUq+F3OOEIBq7dfKGoU="
      }, {
        "num_cand": "U2FsdGVkX1+Pzk57La7JkdQX/cD0X2k/236muDLD3ME=",
        "cpf": "U2FsdGVkX1/f7xoDxotGrPIGNHgd45pfTjPuJyJBuyk="
      }, {
        "num_cand": "U2FsdGVkX18zpS47zEKQS9PnZZA9awXXcjT4hAoH8vI=",
        "cpf": "U2FsdGVkX18409qJN53+6YU3uufIAdtyeX8144CFDNI="
      }, {
        "num_cand": "U2FsdGVkX19DXfCm9tWSN3tfsf+YbmX621LzajN+Vc4=",
        "cpf": "U2FsdGVkX1/70NFz8e8mUjn97YZOmQ4mtNK12S0173I="
      }, {
        "num_cand": "U2FsdGVkX1/U0BzFX2dkWHIyz0h+WpAq6DTS3H4I44A=",
        "cpf": "U2FsdGVkX18qdJkLdbfoK84JJcY/UeQ8L3a8zkBgWgE="
      }, {
        "num_cand": "U2FsdGVkX1/S5Q6ribt7kU8+Yn4uk+yF06Ig8IurvVY=",
        "cpf": "U2FsdGVkX1+6tU/opG4yqFtZZqYLOvH1xx18eMEl778="
      }, {
        "num_cand": "U2FsdGVkX18pkfidAtSauxRJcpoThnTsU3sY4MiJE/4=",
        "cpf": "U2FsdGVkX1/ejEntuPAdjxpjLN2UL6MJfBf4ZiLqzYk="
      }, {
        "num_cand": "U2FsdGVkX1/pk0A2dgE9YDztAWX1NT5TphB5d717WBA=",
        "cpf": "U2FsdGVkX18JrYj0iwp5rqX4LkUiuAWHgc2BNuYN7q8="
      }, {
        "num_cand": "U2FsdGVkX19VX2JgCh2jJGpwS7Evrz4HmdC4zNL0Yy4=",
        "cpf": "U2FsdGVkX1/pzG9XC42wSeGdWBMyQKY0/A9I12TZ+3Q="
      }, {
        "num_cand": "U2FsdGVkX1+FZah8Th/l0NNwGQfTSO6JPTkrheMb/iM=",
        "cpf": "U2FsdGVkX1+T+caB97vocjXJUceB9pWkdNR73Nu1nkw="
      }, {
        "num_cand": "U2FsdGVkX1/pwHFfZDeoS1h9DGkWYIwBWVNvmUqileM=",
        "cpf": "U2FsdGVkX18Uh6c+uk0NuOQ5s9TVkt6Oe9ka0rY1f7g="
      }, {
        "num_cand": "U2FsdGVkX18iDOAaxCQ6BPigUnpW8yxgXmZY3hcyLxw=",
        "cpf": "U2FsdGVkX187LrWb5HoRYjeVUMJnNjFVZBSaPHJ4lRg="
      }, {
        "num_cand": "U2FsdGVkX19MLHU49PMkeNwlUGNNl0FUodYeTcdxY3k=",
        "cpf": "U2FsdGVkX184VZ2HMDv6Q5RKGHOV0Dm5Pzk//1VLd8U="
      }, {
        "num_cand": "U2FsdGVkX1+WFcVoJhrxDZfSfYvSGP9SUs3LErpA0b0=",
        "cpf": "U2FsdGVkX19ywmYbuyiTExYGysftxHjUSPRyGK8OByA="
      }, {
        "num_cand": "U2FsdGVkX19fCjvrw9IDDqlHCUXkvaKXYW8SWmIQWSA=",
        "cpf": "U2FsdGVkX197bVEEWxFnZFy3qURw9wuLjheJGfS6wjM="
      }, {
        "num_cand": "U2FsdGVkX18N6Of5HuRlPXDBmrxWpohpvCS9R3pnfLs=",
        "cpf": "U2FsdGVkX1+CVwMJRbe29tIP0HZkKwyAIW1YbFsisUQ="
      }]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');

            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2114/2114_xrec_po/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
